import { createSelector } from 'reselect';
import { RootState } from '../../../types';
import { EntityTypes } from '../../../constants/entities';
import { IEntityReducer } from 'core/reducers/entities';
import { IModule } from 'types/domain/module';

const entity = (state: RootState) => state.entity.present;
const id = (state: RootState, id?) => id || state.state[EntityTypes.MODULE];

export const selectModuleVersions = createSelector([entity, id], (entity: IEntityReducer, id) => {
  const module: IModule = entity[EntityTypes.MODULE][id];

  return Object.values(entity[EntityTypes.MODULE_VERSION])
    .filter(
      g =>
        g.status > -1 &&
        ([id, module?.originalId].includes(g.moduleId) || [id, module?.originalId].includes(g.parentModuleId)),
    )
    .sort((a, b) =>
      module.originalId ? (a.moduleId === module.originalId ? -1 : 1) : a.moduleId === module.id ? -1 : 1,
    )
    .map(version => {
      return {
        ...version,
        group: entity[EntityTypes.GROUP][version.groupId],
      };
    });
});
